// extracted by mini-css-extract-plugin
export default {"List_bg_image":"Demo_List_bg_image__nQAkv","data_container":"Demo_data_container__zxqmO","links":"Demo_links__u+ZLx"};